/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Uniqualificationcountry2Inputs */

const en__field_uniqualificationcountry2 = /** @type {(inputs: _Field_Uniqualificationcountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In which country have you gained your higher education entrance qualification?`)
};

const de__field_uniqualificationcountry2 = /** @type {(inputs: _Field_Uniqualificationcountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In welchem Land haben Sie die Hochschulzugangsberechtigung erworben?`)
};

/**
* | output |
* | --- |
* | "In which country have you gained your higher education entrance qualification?" |
*
* @param {_Field_Uniqualificationcountry2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_uniqualificationcountry2 = /** @type {((inputs?: _Field_Uniqualificationcountry2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Uniqualificationcountry2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_uniqualificationcountry2(inputs)
	return de__field_uniqualificationcountry2(inputs)
});
export { _field_uniqualificationcountry2 as "_field_uniQualificationCountry" }